// extracted by mini-css-extract-plugin
module.exports = {"timeFormatWrapper":"TimeFormat_timeFormatWrapper__Rjeqs","timeFormatInner":"TimeFormat_timeFormatInner__3O4Hj","btnWidth":"TimeFormat_btnWidth__2EUEX"};